import React, { useEffect, useState } from "react";
import DTOReviews from "./DTOReviews";
import ReviewsPresenter from "./ReviewsPresenter";

import { useTranslation } from "react-i18next";
function ReviewsController() {
  const { t } = useTranslation();

  return (
    <div>
      <DTOReviews />
      <ReviewsPresenter trans={t} />
    </div>
  );
}

export default ReviewsController;
